import React, { useState, useEffect } from 'react';
import i18n from '../../utils/i18n';

const TextfieldUnit = ({
	idx,
	id,
	title,
	placeholder,
	isRequired = false,
	showAsterix = false,
	value,
	unit = i18n.t('general.currency'),
	onChange,
}) => {
	const [inputValue, setInputValue] = useState(
		value !== undefined && value !== null ? String(value) : ''
	);
	const [isHovered, setIsHovered] = useState(false);

	useEffect(() => {
		if (value !== undefined && value !== null) {
			setInputValue(String(value));
		} else {
			setInputValue('');
		}
	}, [value]);

	const numberWithSpaces = (x) => {
		if (x === null || x === undefined) {
			return '';
		}
		const cleanedInput = String(x).replace(/\s+/g, '');
		return cleanedInput.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	};

	const handleInputChange = (event) => {
		let newValue = event.target.value.replace(/\s+/g, '');
		if (newValue === '') {
			newValue = '0';
		}
		setInputValue(newValue);

		if (onChange) {
			event.target.value = newValue;
			onChange(event);
		}
	};

	const handleMouseEnter = () => {
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	return (
		<div
			style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
			key={idx}>
			<div
				style={{
					display: 'flex',
					fontSize: '14px',
					marginBottom: '4px',
					color: '#0b0f31',
					fontWeight: '500',
				}}>
				{title}
				{showAsterix && isRequired && (
					<span
						style={{
							color: inputValue ? '#4b5080' : '#ff0000',
							marginLeft: '4px',
						}}>
						{' '}
						*
					</span>
				)}
			</div>
			<div
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				style={{
					display: 'flex',
					alignItems: 'center',
					border: `1px solid ${isHovered ? '#1c32f3' : '#e3e5e9'}`,
					borderRadius: '8px',
					paddingLeft: '8px',
					height: '44px',
					backgroundColor: '#ffffff',
					transition: 'border-color 0.2s ease-in-out',
				}}>
				<input
					id={id}
					type='text'
					placeholder={placeholder}
					value={numberWithSpaces(inputValue || '')}
					onChange={handleInputChange}
					required={isRequired}
					style={{
						fontFamily: 'Satoshi, sans-serif',
						fontSize: '14px',
						fontWeight: '500',
						color: '#4b5080',
						border: 'none',
						outline: 'none',
						flex: 1,
					}}
				/>
				<div
					style={{
						height: '100%',
						borderLeft: '1px solid #e3e5e9',
						background: '#fafcfe',
						borderRadius: '0 8px 8px 0',
					}}>
					<span
						style={{
							fontSize: '14px',
							color: '#8791b4',
							fontWeight: '500',
							margin: '0 14px',
							whiteSpace: 'nowrap',
							height: '100%',
							display: 'flex',
							alignItems: 'center',
						}}>
						{unit}
					</span>
				</div>
			</div>
		</div>
	);
};

export default TextfieldUnit;
